function getBrowserCookie(cookieName: string): string | undefined {
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined;
  }

  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const parts = decodedCookie.split(';');

  for (const part of parts) {
    let value = part;
    while (value.charAt(0) === ' ') {
      value = value.substring(1);
    }
    if (value.indexOf(name) === 0) {
      return value.substring(name.length);
    }
  }

  return undefined;
}

function parseConsentGroups(consentCookie: string): string[] {
  const decoded = decodeURIComponent(consentCookie);
  const groupsMatch = /groups=([^&]*)/.exec(decoded);
  if (!groupsMatch) return [];
  return groupsMatch[1].split(',');
}

export const checkAnalyticsConsent = (): boolean => {
  try {
    const consentCookie = getBrowserCookie('OptanonConsent');
    if (!consentCookie) return false;

    const groups = parseConsentGroups(consentCookie);
    return groups.some((group) => group.trim().startsWith('C0002:1'));
  } catch {
    return false;
  }
};

export const checkAnalyticsConsentServerSide = (
  cookies: Record<string, string | undefined>,
): boolean => {
  try {
    const consentCookie = cookies.OptanonConsent;
    if (!consentCookie) return false;

    const groups = parseConsentGroups(consentCookie);
    return groups.some((group) => group.trim().startsWith('C0002:1'));
  } catch {
    return false;
  }
};
